import { service } from '@maia/cart';
import { queryOptions } from '@tanstack/react-query';

export function getMutationCartOptions(
  params: Parameters<typeof service.getMutationCart>[number],
) {
  return queryOptions({
    queryFn: () => service.getMutationCart(params),
    queryKey: ['getMutationCart', params.cartGuid],
  });
}
